import React, {SVGProps} from 'react';
import {ReactComponent} from '../../assets/svg/close.svg';

export default (props: SVGProps<any>): JSX.Element => <ReactComponent {...props} />;
